import { useState, useEffect, useCallback } from 'react';
import { createClient } from '@sanity/client';

const client = createClient({
  projectId: 'row16jlt',
  dataset: 'production',
  apiVersion: '2024-01-28',
  useCdn: true,
});

export function useSanity() {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchShows = useCallback(async () => {
    try {
      setLoading(true);
      const result = await client.fetch(`*[_type == "show" && status == "active"] {
        _id,
        title,
        status,
        description,
        hosts,
        genre,
        "imageUrl": image.asset->url,
        "episodes": *[_type == "episode" && references(^._id) && status == "published"] {
          _id,
          title,
          status,
          description,
          show,
          episodeNumber,
          guests,
          recordingDate,
          duration,
          "imageUrl": image.asset->url,
          "audioUrl": audioFile.asset->url
        } | order(episodeNumber desc)
      } | order(title asc)`);

      setShows(result);
      setError(null);
    } catch (err) {
      console.error('Error fetching shows:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchShows();
  }, [fetchShows]);

  return { shows, loading, error, refetch: fetchShows };
}
